export default function getApiUrl (path) {
  if (path.charAt(path.length - 1) === '/') {
    path = path.substr(0, path.length - 1)
  }
  if (path.charAt(0) === '/') {
    path = path.substr(1)
  }
  return `/static/json/views/${path}.json`
}



// WEBPACK FOOTER //
// ./src/utils/getApiUrl.js